import { useEffect, useRef } from 'react';

import { useWindowFocus } from './useWindowFocus';

/**
 * A hook that runs a callback when the window focus changes.
 *
 * @param callback A callback to run when the window focus changes. Receives
 * `isFocused` as an argument.
 */
export function useWindowFocusEffect(callback: (isFocused: boolean) => void): void {
  const wasFocused = useRef(true);
  const isFocused = useWindowFocus();

  useEffect(
    function handleFocusChange() {
      if (wasFocused.current !== isFocused) {
        wasFocused.current = isFocused;
        callback(isFocused);
      }
    },
    [isFocused, callback],
  );
}
